import { render, staticRenderFns } from "./HtmlTemplateProduct.vue?vue&type=template&id=6f249ece&scoped=true&"
import script from "./HtmlTemplateProduct.vue?vue&type=script&lang=js&"
export * from "./HtmlTemplateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f249ece",
  null
  
)

export default component.exports